export const deepConvertBigInt = (obj) => {
    if (obj === null || typeof obj !== 'object')
        return obj;
    for (const key in obj) {
        const value = obj[key];
        if (typeof value === 'bigint') {
            obj[key] = value.toString();
        }
        else if (typeof value === 'object') {
            deepConvertBigInt(value);
        }
    }
    return obj;
};
